import { PH_NO_CAPTURE } from "@/constants/posthog";
import { ScanThumbnail } from "@/components/Thumbnail/ScanThumbnail";
import { selectScanFilename } from "@/store/slices/casesSlice";
import { RootState } from "@/store/store";
import { Box, Typography } from "@mui/material";
import { Dispatch, FC, SetStateAction } from "react";
import { useSelector } from "react-redux";

interface Props {
  uploadId: number;
  scanId: string;
  status?: string;
  setStatus?: Dispatch<SetStateAction<string>>;
  disabled?: boolean;
  isDragging?: boolean;
}

export const ListingPatientScanInfo: FC<Props> = ({ uploadId, scanId, disabled = false, isDragging }) => {
  const selectedFilename = useSelector((state: RootState) => selectScanFilename(state, scanId));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        gap: "8px",
        minWidth: 0,
        opacity: disabled || isDragging ? "0.6" : "1",
        img: disabled ? { filter: "grayscale(1) !important" } : undefined
      }}
    >
      <ScanThumbnail caseId={uploadId} scanId={scanId} />

      {/* Filename */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          className={PH_NO_CAPTURE}
          variant="body2"
          noWrap
          title={selectedFilename}
          sx={{
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%"
          }}
        >
          {selectedFilename}
        </Typography>
      </Box>
    </Box>
  );
};
